// React
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Libs
import { Button, Icon, Menu } from 'semantic-ui-react';

// Config
import { routesConfig } from '../../routes/routes.config';

// Styles
import styles from './LeadDetails.module.css';

// Types
type LeadDetailsToolbarComponentProps = {
    task: any | undefined;
    canClose: boolean;
    onModalOpen: (v: true) => void;
    onConfirmationOpen: (v: true) => void;
    onRefresh: () => void;
};

/**
 * Wrapper component as toolbar for lead's details
 *
 * @param props LeadDetailsToolbarComponentProps
 * @returns React.ReactElement
 */
export default function LeadDetailsToolbarComponent(props: LeadDetailsToolbarComponentProps): React.ReactElement {
    const [isTask, setIsTask] = useState(false);
    const [task, setTask] = useState<string | undefined>();

    const { t } = useTranslation();
    const navigate = useNavigate();

    function onBackClick() {
        navigate(routesConfig.entry + routesConfig.list, { replace: true });
    }

    useEffect(() => {
        setIsTask(false);

        if (props.task) {
            setIsTask(true);
            setTask(props.task);
        }
    }, [props.task]);

    return (
        <>
            <Menu>
                {/* BACK to overview */}
                <Menu.Item onClick={onBackClick}>
                    <Icon name="arrow left" />
                    {t('lead.detail.tools.back')}
                </Menu.Item>

                {/* REFRESH the data */}
                <Menu.Item onClick={props.onRefresh} data-testid={`LeadDetailsToolbar.update-details`}>
                    <Icon name="redo" />
                    {t('lead.detail.tools.refresh')}
                </Menu.Item>

                <Menu.Item>&nbsp;</Menu.Item>

                {/* WORKFLOW TASK */}
                {isTask && (
                    <Menu.Item>
                        <Button
                            onClick={() => props.onModalOpen(true)}
                            style={{ padding: '0', background: 'white', display: 'flex', alignItems: 'center' }}
                            data-testid={`button-manual-task-${task}`}>
                            <div style={{ width: '30px' }}>
                                <svg viewBox="0 0 30 30">
                                    <circle cx="15" cy="15" r="15" fill="#644af3" />
                                    <circle cx="15" cy="15" r="13" fill="#8a70ff" />
                                    <circle cx="11" cy="11" r="3" fill="#fff" />
                                    <circle cx="11" cy="19" r="3" fill="#fff" />
                                    <circle cx="19" cy="11" r="3" fill="#fff" />
                                    <circle cx="19" cy="19" r="3" fill="#fff" />
                                </svg>
                            </div>
                            &nbsp;&nbsp;
                            {t(`lead.detail.tools.tasks.${task}`)}
                        </Button>
                    </Menu.Item>
                )}

                {/* WORKFLOW TASK cancel BY SPECIAL CONDITIONS */}
                {props.canClose && (
                    <Menu.Item>
                        <Button
                            onClick={() => props.onConfirmationOpen(true)}
                            style={{ padding: '0', background: 'white', display: 'flex', alignItems: 'center' }}
                            data-testid={`LeadDetailsToolbar.close-lead`}>
                            <div style={{ width: '30px' }}>
                                <svg viewBox="0 0 30 30">
                                    <circle cx="15" cy="15" r="15" fill="#d7d7d7" />
                                    <circle cx="15" cy="15" r="12" className={styles.inner} />
                                    <circle cx="15" cy="15" r="8" fill="#bf686e" />
                                    <circle cx="15" cy="15" r="7" className={styles.inner} />
                                </svg>
                            </div>
                            &nbsp;&nbsp;
                            {t(`lead.detail.tools.tasks.CANCEL`)}
                        </Button>
                    </Menu.Item>
                )}
            </Menu>
        </>
    );
}
